import axios from "axios";
import { config, config_multipart } from "../../api-helper/api-header-configs";
const baseURL = process.env.REACT_APP_API_URL;

// Get Active Categories
export const get_active_categories = async () => {
    const response = await axios.get(baseURL + "/active_categories", {
        params: {
            _t: Date.now()
        }
    });
    return response.data;
}

// Get All Subcategories Of Category
export const get_all_subcategories_of_category = async (categoryId: string) => {
    const response = await axios.get(baseURL + `/all_subcategories_of_category/${categoryId}`, {
        params: {
            _t: Date.now()
        }
    });
    return response.data;
}

// Get Active Subcategories
export const get_active_subcategories = async () => {
    const response = await axios.get(baseURL + "/active_subcategories", {
        params: {
            _t: Date.now()
        }
    });
    return response.data;
}

// Get Active Subcategories Of Category
export const get_active_subcategories_of_category = async (categoryId: string) => {
    const response = await axios.get(baseURL + `/active_subcategories_of_category/${categoryId}`, {
        params: {
            _t: Date.now()
        }
    });
    return response.data;
}

// Get Active Tags
export const get_active_tags = async () => {
    const response = await axios.get(baseURL + "/active-tags", {
        params: {
            _t: Date.now()
        }
    });
    return response.data;
}

// Get Active Platforms
export const get_active_platforms = async () => {
    const response = await axios.get(baseURL + "/active_platforms", {
        params: {
            _t: Date.now()
        }
    });
    return response.data;
}

// Get Active Projects
export const get_active_projects = async () => {
    const response = await axios.get(baseURL + "/active_projects", {
        params: {
            _t: Date.now()
        }
    });
    return response.data;
}

// Get Active Subprojects
export const get_active_subprojects = async () => {
    const response = await axios.get(baseURL + "/active_subprojects", {
        params: {
            _t: Date.now()
        }
    });
    return response.data;
}

// Get All Subprojects Of Project
export const get_all_subprojects_of_project = async (projectId: string) => {
    const response = await axios.get(baseURL + `/all_subprojects_of_project/${projectId}`, {
        params: {
            _t: Date.now()
        }
    });
    return response.data;
}

// Get Active Subprojects Of Project
export const get_active_subprojects_of_project = async (projectId: string) => {
    const response = await axios.get(baseURL + `/active_subprojects_of_project/${projectId}`, {
        params: {
            _t: Date.now()
        }
    });
    return response.data;
}

// Get All Projects for Download Modal
export const get_all_projects_for_download = async () => {
    const response = await axios.get(baseURL + "/projects", config);
    return response.data;
}

// Get All Subprojects for Download Modal
export const get_all_subprojects_for_download = async (projectId: string) => {
    const response = await axios.get(baseURL + `/subprojects?project_id=${projectId}`, config);
    return response.data;
}

// Get License Files for Subproject (Mock for now - replace with actual API)
export const get_license_files_for_subproject = async (subprojectId: number) => {
    // TODO: Replace with actual API endpoint when available
    // For now, returning mock data structure
    const mockLicenseFiles = [
        { id: 1, file_name: 'License Agreement.pdf' },
        { id: 2, file_name: 'Terms and Conditions.pdf' },
        { id: 3, file_name: 'Usage Rights.pdf' }
    ];
    return { data: { license_files: mockLicenseFiles } };
}

// Associate Asset with Project/Subproject and License Files
export const associate_asset_with_project = async (assetId: number, projectId: number, subprojectId: number, licenseFileIds: number[]) => {
    const payload = {
        asset_id: assetId,
        project_id: projectId,
        subproject_id: subprojectId,
        license_file_ids: licenseFileIds
    };
    const response = await axios.post(baseURL + "/associate-asset-project", payload, config);
    return response.data;
}

// Download Asset with License Files Upload
export const download_asset_with_licenses = async (
    uploadId: number,
    subprojectId: number,
    licenses: Array<{
        license_date?: string;
        license_text?: string;
        license_file?: File;
    }>
) => {
    const formData = new FormData();
    formData.append('upload_id', uploadId.toString());
    formData.append('subproject_id', subprojectId.toString());
    
    licenses.forEach((license, index) => {
        if (license.license_date) {
            formData.append(`licenses[${index}][license_date]`, license.license_date);
        }
        if (license.license_text) {
            formData.append(`licenses[${index}][license_text]`, license.license_text);
        }
        if (license.license_file) {
            formData.append(`licenses[${index}][license_file]`, license.license_file);
        }
    });
    
    const response = await axios.post(baseURL + "/download_asset", formData, config_multipart);
    return response.data;
}

